import type { InputSource } from '../types';

export const none: InputSource = {
  label: 'None',
  value: 'none',
  draw: (ctx, width, height) => {
    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, width, height);
  },
};
